import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function minimaleEisenPerInfrastructuurReducer(state = initialState.minimaleEisenPerInfrastructuur, action) {
	switch (action.type) {
		case types.MINIMALE_EISEN_PER_INFRASTRUCTUUR_LOADED: {
			return Object.assign({},
				state,
				{
					id: action.body.item ? action.body.item.dossierId : null,
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		case types.MINIMALE_EISEN_PER_INFRASTRUCTUUR_SAVED: {
			return Object.assign({},
				state,
				{
					id: action.body.item.dossierId,
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		default:
			return state;
	}
}
